export default class full_screen {
    constructor() {
        this.full_screen_box = document.createElement(`div`)
    }
    createEl() {
        this.full_screen_box.style.color = '#fff'
        this.full_screen_box.style.fontSize = '30px'
        this.full_screen_box.style.float = 'right'
        this.full_screen_box.style.marginTop = '4px'
        this.full_screen_box.style.marginRight = '8px'
        this.full_screen_box.style.cursor = 'pointer'
        this.full_screen_box.setAttribute('id', 'full_screen')
        this.full_screen_box.setAttribute('class', 'icon-lily icon-lily-quanping')
        let prismPlayer = document.querySelector('.prism-controlbar')
        let qualityComponents = document.querySelector('.quality-components')
        // 将全屏按钮添加到.quality-components 元素前
        if (qualityComponents) {
            qualityComponents.parentNode.insertBefore(this.full_screen_box, qualityComponents)
        } else {
            prismPlayer.appendChild(this.full_screen_box)
        }
        this.full_screen_box.onclick = function () {
            try {
                let full_screen = document.querySelector('#full_screen')
                // console.log(full_screen.classList);
                let l_learn_content_container = document.querySelector(
                    '.l-learn-content-container'
                )
                if (full_screen.className.indexOf('icon-lily-quanping') > -1) {
                    full_screen.setAttribute(
                        'class',
                        'icon-lily icon-lily-quxiaoquanping'
                    )
                    l_learn_content_container.classList.add('isfullScreen')
                } else {
                    full_screen.setAttribute('class', 'icon-lily icon-lily-quanping')
                    l_learn_content_container.classList.remove('isfullScreen')
                }
            } catch (error) {
                console.log(error)
            }
        }
    }
    timeupdate() { }
}
